const formatMarkerProps = ({
  url,
  anchor,
  size,
  scaledSize
}) => ({
  url,
  ...anchor ? { anchor: new window.google.maps.Point(anchor.x, anchor.y) } : {},
  ...size ? { size: new window.google.maps.Size(size.width, size.height) } : {},
  ...scaledSize ? { scaledSize: new window.google.maps.Size(scaledSize.width, scaledSize.height) } : {}
});
function getMarkerProps({
  highlight = false,
  hovered = false,
  inactive = false,
  isUserMarker = false,
  icon: iconProp,
  infoWindow
}) {
  if (isUserMarker) {
    return null;
  }
  const icon = typeof iconProp === "function" ? formatMarkerProps(iconProp({ highlight, hovered, inactive })) : iconProp;
  return {
    icon,
    children: infoWindow
  };
}
export {
  getMarkerProps
};
//# sourceMappingURL=get-marker-props.js.map
